<div class="heading">
    <h1 *ngIf="label">{{label}}</h1>
    <ng-container *ngIf="!label">
        <div class="navigation-bar">
            <button class="back-button" (click)="navigateUserToBackPage()">
                <img src="https://cdn.lokos.in/aajeevika/assets/img/back_button_icon.svg" alt="">
                <p class="btn-text">{{backButtonLabel | translate}} <span *ngIf="backButtonOptionalLabel"> ({{backButtonOptionalLabel}})</span></p>
            </button>
            <button *ngIf="showHome" class="home-button" (click)="navigateUserToHome()">
                <img src="https://cdn.lokos.in/aajeevika/assets/img/livelihood-activities.svg" alt="">
            </button>
        </div>
    </ng-container>
</div>
